if (!customElements.get('sticky-product-cart')) {
  customElements.define('sticky-product-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.root = this.closest('.shopify-section');
      this.form = document.getElementById(this.dataset.formId);
      this.sourceButton = this.form?.querySelector('[name="add"]');
      if (!this.root || !this.sourceButton) return;
      this.initialized = true;
      this.button = this.querySelector('[data-sticky-add]');
      this.price = this.querySelector('[data-sticky-price]');
      this.selection = this.querySelector('[data-sticky-selection]');
      this.sourcePrice = document.getElementById('price-' + this.dataset.sectionId);
      try {
        this.variants = JSON.parse(this.root.querySelector('[data-product-json]')?.textContent || '{}').variants || [];
      } catch {
        this.variants = [];
      }
      this.sync = this.sync.bind(this);
      this.updateVisibility = this.updateVisibility.bind(this);
      this.button.addEventListener('click', () => {
        if (this.sourceButton.disabled || this.sourceButton.classList.contains('is-loading')) return;
        this.sourceButton.click();
        this.sync();
      });
      this.observer = new IntersectionObserver(this.updateVisibility, {threshold: 0});
      this.observer.observe(this.sourceButton);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.sourceButton, {attributes: true, childList: true, subtree: true, characterData: true});
      if (this.sourcePrice) this.mutations.observe(this.sourcePrice, {attributes: true, childList: true, subtree: true, characterData: true});
      this.root.addEventListener('change', this.sync);
      window.addEventListener('resize', this.updateVisibility);
      this.resizeObserver = new ResizeObserver(() => {
        if (!this.hidden) document.body.style.setProperty('--sticky-product-cart-height', this.offsetHeight + 'px');
      });
      this.resizeObserver.observe(this);
      this.sync();
      this.updateVisibility();
    }

    sync() {
      const loading = this.sourceButton.classList.contains('is-loading');
      this.button.disabled = this.sourceButton.disabled || loading;
      this.button.setAttribute('aria-busy', String(loading));
      const text = this.sourceButton.querySelector('.button__text')?.textContent.trim() || this.sourceButton.textContent.trim();
      if (this.button.textContent !== text) this.button.textContent = text;
      const priceHTML = this.sourcePrice?.querySelector('.price')?.outerHTML;
      if (priceHTML && this.price.innerHTML !== priceHTML) this.price.innerHTML = priceHTML;
      this.price.hidden = this.sourcePrice?.classList.contains('visibility-hidden') || false;
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === variantId);
      let selection = variant && variant.title !== 'Default Title' ? variant.title : '';
      const shaker = this.root.querySelector('[data-shaker-toggle]');
      if (shaker?.checked) selection += (selection ? ' · ' : '') + this.dataset.upsellLabel;
      this.selection.textContent = selection;
    }

    updateVisibility() {
      const passedButton = window.matchMedia('(max-width: 749px)').matches && this.sourceButton.getBoundingClientRect().bottom <= 0;
      this.hidden = !passedButton;
      document.body.classList.toggle('has-sticky-product-cart', passedButton);
      if (passedButton) document.body.style.setProperty('--sticky-product-cart-height', this.offsetHeight + 'px');
      else document.body.style.removeProperty('--sticky-product-cart-height');
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutations?.disconnect();
      this.resizeObserver?.disconnect();
      this.root?.removeEventListener('change', this.sync);
      window.removeEventListener('resize', this.updateVisibility);
      document.body.classList.remove('has-sticky-product-cart');
      document.body.style.removeProperty('--sticky-product-cart-height');
    }
  });
}
